<template>
    <v-card id="pageFooter" class="myprovet-bg-color shepherd-myprovet-footer" style="box-shadow: none; height: 38px; min-height: 38px; max-height: 38px">
        <v-footer padless fixed class="myprovet-background-color footer-borders" style="display: block">
            <div id="desktop" class="hidden-sm-and-down">
                <v-row>
                    <v-col cols="12">
                        <v-card flat tile width="100%" height="49px" class="myprovet-background-color px-10 text-center desktop-card">
                            <v-card-text class="pt-0 my-5">
                                <div class="d-flex justify-space-between align-center pt-1">
                                    <div class="d-flex justify-start align-center">
                                        <a href="https://www.livroreclamacoes.pt/Inicio/" target="_blank" class="mr-4">
                                            <v-img width="100%" max-width="85px" :src="livroReclamacoesUrl"></v-img>
                                        </a>

                                        <div class="footer-text mx-4 mt-1" style="cursor: pointer" @click="openPrivacyPolicyDialog()">{{ tb('Política de Privacidade') }}</div>

                                        <div class="footer-text mx-4 mt-1" style="cursor: pointer" @click="openGeneralConditionsDialog()">{{ tb('Condições Gerais') }}</div>
                                    </div>

                                    <div class="d-flex justify-center align-center">
                                        <social-media :social-media="socialMedia.value" propecLogoClass="mx-4" iconClass="mx-3"></social-media>
                                    </div>

                                    <div style="width: 24%" class="d-flex justify-end align-center">
                                        <v-row>
                                            <v-col cols="12" class="mt-1">
                                                <v-icon small dark left> mdi-phone </v-icon>

                                                <strong class="footer-text" style="cursor: default">
                                                    <b>{{ phoneNumber }}</b>
                                                </strong>
                                            </v-col>

                                            <v-col cols="12" style="margin-top: -10px">
                                                <small class="footer-text-xs" style="cursor: default">
                                                    <span>{{ tb(phoneNumberAdditionalText) }}</span>
                                                </small>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </div>

            <div id="tablet" class="d-none d-sm-flex d-md-none">
                <v-row>
                    <v-col cols="12">
                        <v-card flat tile width="100%" class="myprovet-background-color px-10 text-center">
                            <v-card-text>
                                <v-row class="d-flex align-center pt-1 mb-2">
                                    <v-col cols="12" class="d-flex justify-center align-center">
                                        <social-media :social-media="socialMedia.value" propecLogoClass="mx-4" iconClass="mx-3"></social-media>
                                    </v-col>
                                </v-row>

                                <v-divider></v-divider>

                                <v-row class="d-flex justify-start align-center mt-2 pb-4">
                                    <v-col cols="3" class="d-flex justify-start">
                                        <a class="footer-text">{{ tb('Condições Gerais') }}</a>
                                    </v-col>

                                    <v-col cols="3" class="d-flex justify-center">
                                        <a class="footer-text">{{ tb('Política de Privacidade') }}</a>
                                    </v-col>

                                    <v-col cols="3" class="d-flex justify-center">
                                        <a href="https://www.livroreclamacoes.pt/Inicio/" target="_blank">
                                            <v-img width="100%" max-width="100px" :src="livroReclamacoesUrl"></v-img>
                                        </a>
                                    </v-col>

                                    <v-col cols="3" class="d-flex justify-end">
                                        <v-row>
                                            <v-col cols="12" class="mt-1">
                                                <v-icon small dark left> mdi-phone </v-icon>

                                                <strong class="footer-text" style="cursor: default">
                                                    <b>{{ phoneNumber }}</b>
                                                </strong>
                                            </v-col>

                                            <v-col cols="12" style="margin-top: -10px">
                                                <small class="footer-text-xs" style="cursor: default">
                                                    <span>{{ tb(phoneNumberAdditionalText) }}</span>
                                                </small>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </div>

            <div id="mobile" class="d-flex d-sm-none" style="height: 150px">
                <v-row>
                    <v-col cols="12">
                        <v-card flat tile width="100%" class="myprovet-background-color px-2 text-center">
                            <v-card-text height="80px">
                                <v-row class="d-flex align-center pt-2 mb-2">
                                    <v-col cols="12" class="d-flex justify-center align-center">
                                        <social-media :social-media="socialMedia.value" propecLogoClass="mx-4" iconClass="mx-3"></social-media>
                                    </v-col>
                                </v-row>

                                <v-divider></v-divider>

                                <v-row class="d-flex justify-start align-center mt-1">
                                    <v-col cols="5" class="d-flex justify-center">
                                        <a href="https://www.livroreclamacoes.pt/Inicio/" target="_blank">
                                            <v-img width="100%" max-width="100px" :src="livroReclamacoesUrl"></v-img>
                                        </a>
                                    </v-col>

                                    <v-col cols="7">
                                        <v-row class="mt-2">
                                            <v-col cols="12" class="d-flex justify-center">
                                                <a class="footer-text-mobile">{{ tb('Condições Gerais') }}</a>
                                            </v-col>
                                        </v-row>

                                        <v-row class="mt-0">
                                            <v-col cols="12" class="d-flex justify-center">
                                                <a class="footer-text-mobile">{{ tb('Política de Privacidade') }}</a>
                                            </v-col>
                                        </v-row>

                                        <v-row class="mt-0">
                                            <v-col cols="12" class="d-flex justify-center">
                                                <v-row>
                                                    <v-col cols="12" class="mt-1">
                                                        <v-icon small dark left> mdi-phone </v-icon>

                                                        <strong class="footer-text-mobile" style="cursor: default">
                                                            <b>{{ phoneNumber }}</b>
                                                        </strong>
                                                    </v-col>

                                                    <v-col cols="12" style="margin-top: -5px">
                                                        <small class="footer-text-xs" style="cursor: default">
                                                            <span>{{ tb(phoneNumberAdditionalText) }}</span>
                                                        </small>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-footer>

        <privacy-policy-dialog v-if="isPrivacyPolicyDialogOpen" :value="isPrivacyPolicyDialogOpen" @onCancel="isPrivacyPolicyDialogOpen = false" width="40vw" max-height="80vh"> </privacy-policy-dialog>

        <general-conditions-dialog v-if="isGeneralConditionsDialogOpen" :value="isGeneralConditionsDialogOpen" @onCancel="isGeneralConditionsDialogOpen = false" width="40vw" max-height="80vh"> </general-conditions-dialog>
    </v-card>
</template>

<script>
import useSocialMedia from '@/Composables/SocialMedia';
import { axios } from '@/Services/Backend';

const { socialMedia, getSocialMedia } = useSocialMedia();

export default {
    data: () => ({
        socialMedia,

        livroReclamacoesUrl: '/storage/assets/footer/footer_livro_reclamacoes.png',

        phoneNumber: null,
        phoneNumberAdditionalText: null,

        isPrivacyPolicyDialogOpen: false,
        isGeneralConditionsDialogOpen: false,
    }),

    created() {
        getSocialMedia();

        this.getPhoneNumber();
    },

    methods: {
        openPrivacyPolicyDialog() {
            this.isPrivacyPolicyDialogOpen = true;
        },

        openGeneralConditionsDialog() {
            this.isGeneralConditionsDialogOpen = true;
        },

        getPhoneNumber() {
            axios
                .get('/api/phone-number')
                .then((response) => {
                    this.phoneNumber = response.data.phone_number;
                    this.phoneNumberAdditionalText = response.data.phone_number_additional_text;
                })
                .catch((error) => {
                    console.log(error);
                    this.showError(this.$t('toasts.phoneError'));
                });
        },
    },
};
</script>

<style scoped>
.col {
    padding: 0px !important;
}

.myprovet-background-color {
   /* background-color: #154579 !important;
    border-color: #154579 !important;*/
    background-color: #006DB6 !important;
    border-color: #006DB6!important;
}

.footer-text {
    font-size: 0.75rem !important;
    font-weight: 400 !important;
    font-style: normal !important;
    color: white !important;
    text-decoration: none !important;
}

.footer-text-xs {
    font-size: 0.65rem !important;
    font-weight: 400 !important;
    font-style: normal !important;
    color: white !important;
    text-decoration: none !important;
}

.footer-borders {
    border-top-left-radius: 0px !important;
    border-top-right-radius: 0px !important;
}

.desktop-card {
    display: flex !important;
    align-items: center !important;
}

.footer-text-mobile {
    font-size: 0.875rem !important;
    font-weight: 400 !important;
    font-style: normal !important;
    color: white !important;
    text-decoration: none !important;
}
</style>
